import React, { useEffect, useRef, useState } from "react";
import withRouter from "../../../../withRouter";
import { companyRules1, companyRules2 } from "./companyRules";

function OrientationForm({ object }) {
  const termsList = [
    "Purpose",
    "General Provisions",
    "Work Conditions",
    "Pay Days (Payroll Date)",
    "Employment Status",
    "Code of Discipline",
    "Company Benefits",
    "Deductions",
    "Schedule of final payment (13th Month Pay)",
    "Social Media",
    "Confidential Clause",
    "Grooming Standard",
    "Sexual Harassment Awareness",
    "Drug Free Workplace",
    "Smoke Free Workplace",
    "Workplace Policy & Program on Tuberculosis Prevention and Control",
    "Alcohol Free Workplace Policy and Program",
    "Workplace Policy and Program on Hepatitis B",
    "Employment Contract",
    "Company ID/LGS ID",
    "Hello Money/AUB",
    "Nameplate",
  ];

  const middleIndex = Math.ceil(termsList.length / 2);
  const leftTerms = termsList.slice(0, 12);
  const rightTerms = termsList.slice(12);
  const fullname = `${object?.firstName} ${object?.middleName} ${object?.lastName}`;

  const today = new Date();
  const formattedDate = object?.orientationDate
    ? new Date(object.orientationDate)
        .toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })
        .toUpperCase()
    : new Date()
        .toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })
        .toUpperCase();
  const day = String(today.getDate()).padStart(2, "0");
  const month = today.toLocaleString("default", { month: "long" });
  const year = today.getFullYear();
  const effectivityDate = object?.hireEndDate
    ? new Date(object?.hireEndDate).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "Effectivity Date";
  const reminder =
    "*Reminder: All Non-negotiable requirements are required to RENEW every MARCH of the year.";

  // CSS styles for responsive printing
  const printStyles = `
    @media print {
      body { 
        margin: 0; 
        padding: 0; 
        font-size: 11pt !important;
        line-height: 1.3 !important;
      }
      
      .page {
        page-break-after: always;
        page-break-inside: avoid;
        min-height: 100vh;
        max-height: 100vh;
        display: flex;
        flex-direction: column;
        padding: 0.5in !important;
        margin: 0 !important;
        box-sizing: border-box;
      }
      
      .page:last-child {
        page-break-after: auto;
      }
      
      .logo {
        max-width: 200px !important;
        height: auto !important;
        margin-bottom: 8px !important;
      }
      
      .header-title {
        font-size: 12pt !important;
        padding: 6px 12px !important;
        margin-bottom: 12px !important;
      }
      
      .rule-item {
        margin-bottom: 8px !important;
        font-size: 10pt !important;
        line-height: 1.2 !important;
      }
      
      .rule-number {
        font-size: 10pt !important;
        font-weight: bold !important;
      }
      
      .reminder-text {
        font-size: 9pt !important;
        margin: 4px 0 8px 16px !important;
      }
      
      .agreement-title {
        font-size: 14pt !important;
        margin: 12px 0 !important;
      }
      
      .agreement-text {
        font-size: 10pt !important;
        line-height: 1.3 !important;
        margin-bottom: 8px !important;
      }
      
      .terms-container {
        display: flex !important;
        margin: 12px 0 !important;
      }
      
      .terms-column {
        flex: 1 !important;
        border: 1px solid black !important;
        padding: 8px 12px !important;
        font-size: 9pt !important;
      }
      
      .terms-column:last-child {
        border-left: none !important;
      }
      
      .term-item {
        margin-bottom: 2px !important;
        display: flex !important;
        align-items: center !important;
      }
      
      .term-checkbox {
        width: 12px !important;
        height: 12px !important;
        margin-right: 8px !important;
        flex-shrink: 0 !important;
      }
      
      .signature-section {
        margin-top: 16px !important;
        display: flex !important;
        justify-content: flex-start !important;
      }
      
      .signature-container {
        text-align: center !important;
        flex: 0 0 300px !important;
      }
      
      .signature-img {
        max-width: 80px !important;
        margin-bottom: 12px !important;
      }
      
      .contact-info {
        text-align: center !important;
        margin: 12px 0 !important;
        font-size: 10pt !important;
      }
      
      .orientation-section {
        display: flex !important;
        justify-content: flex-end !important;
        margin-top: 16px !important;
      }
      
      .orientation-signature {
        border-top: 1px solid black !important;
        margin-top: 24px !important;
        font-size: 10pt !important;
      }
    }
    
    @media screen {
      .page {
        margin-bottom: 2rem;
        padding: 1.5rem;
        box-shadow: 0 0 10px rgba(0,0,0,0.1);
        background: white;
        min-height: 90vh;
      }
      
      .logo {
        max-width: min(300px, 80vw);
      }
      
      .terms-container {
        display: flex;
        flex-wrap: wrap;
        gap: 0;
      }
      
      .terms-column {
        flex: 1;
        min-width: 250px;
        border: 1px solid black;
        padding: 8px 15px;
      }
      
      .terms-column:last-child {
        border-left: none;
      }
      
      @media (max-width: 768px) {
        .terms-column {
          min-width: 100%;
          border-left: 1px solid black !important;
        }
        
        .signature-container {
          flex: 1 !important;
        }
      }
    }
  `;

  return (
    <>
      <style>{printStyles}</style>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingLeft: "16px",
          paddingRight: "16px",
        }}
      >
        {/* Page 1 – companyRules1 */}
        <div className="page">
          <img
            src="/lgsnobg.png"
            alt="LGS Logo"
            className="logo"
            style={{
              alignSelf: "center",
              marginBottom: "8px",
            }}
          />
          <p
            className="header-title"
            style={{
              fontWeight: "bold",
              textAlign: "center",
              border: "2px solid #000",
              padding: "8px 16px",
              alignSelf: "center",
              width: "70%",
              marginBottom: "16px",
            }}
          >
            COMPANY RULES AND PROCEDURES FOR NEW EMPLOYEE
          </p>

          {companyRules1.map((companyRule, index) => (
            <div key={index} className="rule-item">
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "flex-start",
                }}
              >
                <p
                  className="rule-number"
                  style={{ marginBottom: 0, minWidth: "20px" }}
                >
                  {index + 1}.
                </p>
                <p style={{ marginBottom: 0, flex: 1 }}>{companyRule}</p>
              </div>
              {index === 0 && (
                <p
                  className="reminder-text"
                  style={{
                    marginLeft: "16px",
                    margin: "4px 0 8px 30px",
                    fontStyle: "italic",
                  }}
                >
                  {reminder}
                </p>
              )}
            </div>
          ))}
        </div>

        {/* Page 2 – companyRules2 */}
        <div className="page">
          {companyRules2.map((companyRule, index) => (
            <div key={index} className="rule-item">
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "flex-start",
                }}
              >
                <p
                  className="rule-number"
                  style={{ marginBottom: 0, minWidth: "20px" }}
                >
                  {index + 16}.
                </p>
                <p style={{ marginBottom: 0, flex: 1 }}>{companyRule}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Page 3 – Orientation Agreement */}
        <div className="page">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <img
              src="/lgsnobg.png"
              alt="LGS Logo"
              className="logo"
              style={{
                alignSelf: "center",
                marginBottom: "16px",
              }}
            />

            <p
              className="agreement-title"
              style={{
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "18px",
                marginBottom: "16px",
              }}
            >
              ORIENTATION ACKNOWLEDGEMENT & ACCEPTANCE FORM
            </p>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                marginBottom: "16px",
              }}
            >
              <p className="agreement-text">
                I,
                <u style={{ margin: "0 8px" }}>
                  <strong>{fullname}</strong>
                </u>
                with permanent address at
                <u style={{ margin: "0 8px" }}>
                  <strong>
                    {object?.permanent_houseNumber}, {object?.permanent_street},{" "}
                    {object?.permanent_subdivision},{" "}
                    {object?.permanent_barangay}, {object?.permanent_city},{" "}
                    {object?.permanent_province}
                  </strong>
                </u>
                probationary employee of LGS STAFF MANAGEMENT SERVICES, INC.
                Effective on
                <u style={{ margin: "0 8px" }}>
                  <strong>{effectivityDate}</strong>
                </u>
              </p>
              <p className="agreement-text">
                That I have accepted and confirm that I accept all the term and
                conditions stated in the COMPANY Rules and Regulations as listed
                below and it was fully explained to me by the officer of the
                COMPANY.
              </p>
            </div>

            <div className="terms-container">
              <div className="terms-column">
                {leftTerms.map((term, index) => (
                  <div key={index} className="term-item">
                    <input
                      type="radio"
                      className="term-checkbox"
                      style={{
                        width: "15px",
                        marginRight: "8px",
                        height: "15px",
                        borderRadius: "50%",
                        appearance: "none",
                        border: "2px solid #ccc",
                        outline: "none",
                        cursor: "pointer",
                        backgroundColor: "black",
                      }}
                      checked={true}
                      readOnly
                    />
                    <label style={{ fontSize: "10px" }}>{term}</label>
                  </div>
                ))}
              </div>

              <div className="terms-column">
                {rightTerms.map((term, index) => (
                  <div key={12 + index} className="term-item">
                    <input
                      type="radio"
                      className="term-checkbox"
                      style={{
                        width: "15px",
                        marginRight: "8px",
                        height: "15px",
                        borderRadius: "50%",
                        appearance: "none",
                        border: "2px solid #ccc",
                        outline: "none",
                        cursor: "pointer",
                        backgroundColor: "black",
                      }}
                      checked={true}
                      readOnly
                    />
                    <label style={{ fontSize: "10px" }}>{term}</label>
                  </div>
                ))}
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                marginTop: "16px",
              }}
            >
              <p className="agreement-text">
                That I have read and fully understood the rules and regulations
                of the COMPANY and I promise to abide and adhere to all
                conditions stated therein.
              </p>
              <p className="agreement-text">
                Should I in any way commit infractions with respect to the Rules
                and Regulations of LGS STAFF MANAGEMENT SERVICES INCORPORATED, I
                am aware that I shall be subjected to sanctions as specified
                therein.
              </p>
              <p className="agreement-text">
                I am hereby affixing my signature on this <u>{day}</u> day of{" "}
                <u>
                  {month} 20{String(year).slice(2)}
                </u>{" "}
                in my own free will and without coercion.
              </p>
            </div>

            <div className="signature-section">
              <div className="signature-container">
                {object?.signature && (
                  <div style={{ marginBottom: "12px" }}>
                    <img
                      src={object?.signature}
                      alt="Signature Preview"
                      className="signature-img"
                      style={{
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                      }}
                    />
                  </div>
                )}
                <u>
                  {fullname.toUpperCase()} {formattedDate}
                </u>
                <p style={{ fontSize: "12px", marginTop: "4px" }}>
                  Staff Signature over printed name/Date
                </p>
              </div>
            </div>

            <div className="contact-info">
              <p style={{ marginBottom: "8px" }}>
                Please let us know if you have any questions or clarifications.
              </p>
              <div>
                <b>LGS STAFF MANAGEMENT SERVICES INC.</b>
                <br />
                <b>
                  Office Address: Office Address: LGS Centre, 1639 Dian corner,
                  Rockefeller St. Brgy. San Isidro, <br />
                  Makati City, 1234 Philippines
                </b>
                <br />
                <b>Tel: (632) 8889-2680</b>
              </div>
            </div>

            <div className="orientation-section">
              <div style={{ textAlign: "center" }}>
                <p style={{ fontSize: "12px", marginBottom: "8px" }}>
                  Orientation conducted by:
                </p>
                <div className="orientation-signature"></div>
                <p style={{ fontSize: "12px", marginTop: "8px" }}>
                  Signature over printed name
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OrientationForm;
